import {DTO} from '@/shared/base/dto';
import {ENDPOINT, METHOD} from '@/constants';

export class ResetPassResponse {
  public message!: string;
  public timestamp!: string;
}

export class ResetPassQuery {
  public password!: string;
  public token!: string;
}

export class ResetPassDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.RESET_PASS;
  public method = METHOD.POST;
  public readonly responseClass = ResetPassResponse;
  public query: undefined;
  constructor(public body: ResetPassQuery) {
    super();
  }
}
